import { z } from "zod/v4";
import { ClientApiFeaturePathParams, defineEndpoint, defineResource } from "@visioni/a3s-client-api";
import { FEATURE_NAME } from "../constants";

export const CommandBody = z.object({
  action: z.literal("open"),
});
export type CommandBody = z.output<typeof CommandBody>;

export const CommandResponse = z.object({ requestId: z.string() });
export type CommandResponse = z.output<typeof CommandResponse>;

export type CommandPathParams = ClientApiFeaturePathParams;

export const commandsResource = defineResource({
  feature: FEATURE_NAME,
  resource: "commands",
});

export const openGateEndpoint = defineEndpoint(commandsResource, {
  method: "POST",
  bodySchema: CommandBody,
  responseSchema: CommandResponse,
});
